'use client';

import React from 'react';

export const useUnmount = () => {
  const isUnmounted = React.useRef(false);

  React.useEffect(() => {
    isUnmounted.current = !isUnmounted.current;
  }, []);

  return isUnmounted;
};
